/* import __COLOCATED_TEMPLATE__ from './gcs-config-bucket.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

import type IntlService from 'ember-intl/services/intl';
import type NotificationsService from 'embercom/services/notifications-service';

interface Signature {
  Args: {
    exportDefinitionPersisted: boolean;
    bucketName: string;
    maxBucketNameLength: number;
    resetBucketVerification: () => void;
  };
}

export default class GcsConfigBucket extends Component<Signature> {
  @service declare notificationsService: InstanceType<typeof NotificationsService>;
  @service declare intl: IntlService;

  get bucketPrinciple() {
    return 'intercom-bulk-export-wif@intercom-bulk-export-476709.iam.gserviceaccount.com';
  }

  async copyValue(value: string) {
    await navigator.clipboard.writeText(value);
    this.notificationsService.notifyConfirmation(
      this.intl.t('settings.bulk-export.gcs-config.value-copied'),
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::BulkExport::ConfigurationDataExport::GcsConfigBucket': typeof GcsConfigBucket;
    'settings/bulk-export/configuration-data-export/gcs-config-bucket': typeof GcsConfigBucket;
  }
}
